import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

// Selectors
import {
  selectBuyingReportRoute,
  selectRouteToSearch,
} from '../../../../store/selectors/routes'
import { selectListingsSourceIsHomebotListings } from '../../../../store/selectors/listings'

// Actions
import { setCreateClientFrom } from '../../../../actions/navigation'

// Components
import { Button } from '@homebot/shared-ui-swashbuckle'

// Helpers
import { dispatchEvent } from '../../../../helpers/tagManager'

// Constants
import { StartYourSearchClick } from '../../../../constants/trackingEvents'
import { defineMessages, useIntl } from 'react-intl'

interface BuyersLinkProps {
  className?: string
  affordability: number
  from: string
}

const MSG = defineMessages({
  startYourSearch: {
    id: 'Homeowner.purchasePower.explore',
    defaultMessage: 'Start your search',
  },
})

export const BuyersLink = ({
  className,
  affordability,
  from,
}: BuyersLinkProps) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const intl = useIntl()

  const homebotListingEnabled = useSelector(
    selectListingsSourceIsHomebotListings
  )
  const pathname = useSelector(selectBuyingReportRoute)

  const to = {
    pathname,
    affordability,
  }
  const listingsPath = useSelector(selectRouteToSearch)

  const handleOnClick = () => {
    dispatch(setCreateClientFrom(from))
    dispatchEvent(StartYourSearchClick, {
      eventLabel: `${from}_PURCHASE_POWER`,
    })
    // "affordability is being added to the location object and consumed in InitializeContainer, where it is then passed to "ConfirmCreateBuyer"
    // this is weird and bad, but I'm afraid to touch it right now - it should probably be a query string param, or set in redux state
    history.push(to)
  }

  const handleHomebotListingsClick = () => {
    history.push(listingsPath)
  }

  return (
    <Button
      className={className}
      onClick={
        homebotListingEnabled ? handleHomebotListingsClick : handleOnClick
      }
    >
      {intl.formatMessage(MSG.startYourSearch)}
    </Button>
  )
}
